export const BORDER_RADIUS = '10px';
export const BORDER = '2px dashed';
export const BORDER_COLOR = 'gray.400';
export const BACKGROUND_COLOR = 'gray.50';
